import React, { Component, Fragment } from "reactn";
import styled from "styled-components";
import Loadable from "js/react/components/Loadable";
import { BlueButton, IconMenu, RoundIconButton, UIPane } from "js/react/components/UiComponents";
import {
    ShowConfirmationDialog,
    ShowDialog,
    ShowErrorDialog,
    ShowInputDialog
} from "js/react/components/Dialogs/BaseDialog";
import { ds } from "js/core/models/dataService";
import { FlexBox, ScrollBox } from "js/react/components/LayoutGrid";
import { FlexSpacer, Gap10, Gap20, Gap30 } from "js/react/components/Gap";
import { Icon, IconButton, MenuItem } from "@material-ui/core";
import { _ } from "js/vendor";
import { PresentationLibraryController } from "js/editor/PresentationLibrary/PresentationLibraryController";
import { themeColors } from "js/react/sharedStyles";
import {
    PresentationTemplateController,
    PresentationTemplateDataService
} from "js/core/dataServices/PresentationTemplateDataService";
import { SlideThumbnail } from "js/react/views/AddSlide/Panes/Components/ThumbnailGrid";
import { CreateNewPresentationDialog } from "js/editor/CreatePresentationDialog/CreateNewPresentationDialog";
import { Breadcrumb } from "js/editor/PresentationLibrary/PresentationLibrary";
import { NoTeamTemplateNotice } from "js/react/views/UserOptions/dialogs/NoResourcesNotices";
import { PERMISSION_RESOURCE_TYPE } from "common/constants";
import { UIController } from "js/editor/dialogs/UIController";
import { SearchBarContainer, UIPaneResultsContainer } from "js/react/views/AddSlide/Panes/Components/SearchBox";

export default class TeamTemplatesPane extends Component {
    state = {
        items: [],
        isLoading: true,
    }

    componentDidMount() {
        this.dataService = new PresentationTemplateDataService({
            onCollectionChanged: items => {
                items = _.sortBy(items, "name");
                this.setState({ items, isLoading: false });
            }
        });
    }

    componentWillUnmount() {
        this.dataService.unsubscribe();
    }

    handleAddItem = () => {
        ShowDialog(CreateNewPresentationDialog, {
            isTeamTemplate: true,
            callback: async presentation => {
                let presentationTemplate = await PresentationTemplateController.convertToPresentationTemplate(presentation);
                if (presentationTemplate) {
                    PresentationLibraryController.editPresentation(presentationTemplate, false);
                }
            }
        });
    }

    handleEditItem = item => {
        let presentation = ds.presentations.get(item.id);
        PresentationLibraryController.editPresentation(presentation, false);
    }

    handleRenameItem = async item => {
        let presentation = ds.presentations.get(item.id);

        let name = await ShowInputDialog({
            title: "Rename Template",
            maxChars: 50,
            value: item.name
        });

        if (name) {
            try {
                presentation.update({ name });
                item.name = name;
                this.forceUpdate();
            } catch (err) {
                ShowErrorDialog({
                    title: "Unable to rename presentation",
                    message: err.message
                });
            }
        }
    }

    handleDeleteItem = async item => {
        if (await ShowConfirmationDialog({
            title: "Are you sure you want to delete this template?",
            message: "This action can not be undone."
        })) {
            PresentationTemplateController.deletePresentationTemplate(item);
        }
    }

    handleChangePublishState = async (item, state) => {
        let presentation = ds.presentations.get(item.id);

        if (state) {
            await PresentationTemplateController.publishPresentationTemplate(presentation);
            item.isPublished = true;
        } else {
            await PresentationTemplateController.unpublishPresentationTemplate(presentation);
            item.isPublished = false;
        }
        this.forceUpdate();
    }

    render() {
        let { items, isLoading } = this.state;

        return (
            <UIPane style={{ width: "calc(100vw - 260px)" }}>
                <SearchBarContainer className="search-container">
                    <Breadcrumb>Team Templates</Breadcrumb>
                    <RoundIconButton onClick={this.handleAddItem}><Icon>add</Icon></RoundIconButton>
                </SearchBarContainer>
                <UIPaneResultsContainer>
                    <Loadable isLoading={isLoading}>
                        {items.length > 0 && items.map(item => {
                            const onDelete = () => this.handleDeleteItem(item);
                            return (
                                <PresentationTemplateItem
                                    key={item.id} item={item} readOnly={false}
                                    onRename={() => this.handleRenameItem(item)}
                                    onEdit={() => this.handleEditItem(item)}
                                    onDelete={onDelete}
                                    onChangePublishState={state => this.handleChangePublishState(item, state)}
                                />
                            );
                        }
                        )}
                        {items.length == 0 &&
                        <FlexBox fill>
                            <NoTeamTemplateNotice/>
                        </FlexBox>
                        }
                    </Loadable>
                </UIPaneResultsContainer>
            </UIPane>
        );
    }
}

const TemplateItem = styled.div`
  width: 100%;
 // max-width: calc(100vw - 310px);
  margin-bottom: 20px;
  background: white;
  padding: 10px 20px 10px 20px;
  border: solid 1px white;
  &:hover {
    border: solid 1px ${themeColors.ui_blue};
  }
  &.selected {
    background: ${themeColors.lightBlue};
  }
  .title {
    font-weight: 600;
    font-size: 16px;
  }
`;

const SlideThumbnailsContainer = styled.div`
    width: 100%;
`;

const SlideThumbnails = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 200px;
  width: 100%;
  overflow-x: auto;
  gap: 10px;
  padding: 10px 1px;
  .thumbnail-container {
      .thumbnail {
        box-shadow: none !important;
        img {
          border: solid 1px #ddd !important;
        }
      }
  }
`;

const PublishLabel = styled.div`
  padding: 5px 10px;
  color: white;
  background: ${props => props.published ? themeColors.ui_blue : "orangered"};
  border-radius: 2px;
  text-transform: uppercase;
  font-size: 12px;
`;

export class PresentationTemplateItem extends Component {
    handlePublish = async () => {
        if (await ShowConfirmationDialog({
            title: "Are you sure you want to publish this Presentation Template to your team?",
            message: "Your team members will be able to create a new presentation starting from this template by selecting it in Create New Presentation dialog."
        })) {
            this.props.onChangePublishState(true);
        }
    }

    render() {
        let { item, readOnly, selected } = this.props;

        return (
            <TemplateItem key={item.id} className={selected ? "selected" : ""} onClick={this.props.onClick} onDoubleClick={this.props.onEdit} readOnly={readOnly}>
                <FlexBox left center fillHeight>
                    <div className="title">{item.name}</div>
                    <Gap20/>
                    {!readOnly && item.isPublished && <PublishLabel published>Published</PublishLabel>}
                    {!readOnly && !item.isPublished && <PublishLabel onClick={this.handlePublish}>Not Published</PublishLabel>}
                    <FlexSpacer/>
                    {
                        !readOnly &&
                        <IconMenu>
                            {item.isPublished && <MenuItem divider onClick={() => this.props.onChangePublishState(false)}><Icon>unpublished</Icon>Unpublish Template</MenuItem>}
                            {!item.isPublished && <MenuItem divider onClick={this.handlePublish}><Icon>published_with_changes</Icon>Publish Template</MenuItem>}
                            <MenuItem divider onClick={this.props.onRename}><Icon>label</Icon>Rename Template</MenuItem>
                            <MenuItem divider onClick={this.props.onEdit}><Icon>edit</Icon>Edit Template...</MenuItem>
                            <MenuItem onClick={this.props.onDelete}><Icon>delete</Icon>Delete Template</MenuItem>
                        </IconMenu>
                    }
                </FlexBox>
                <SlideThumbnailsContainer>
                    <SlideThumbnails>
                        {item.sips.map(slideId => <SlideThumbnail key={slideId} slideId={slideId}/>)}
                    </SlideThumbnails>
                </SlideThumbnailsContainer>
            </TemplateItem>
        );
    }
}

